import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabToggleComponent } from './tab-toggle.component';
import { TabToggleOptionComponent } from './tab-toggle-option/tab-toggle-option.component';

@NgModule({
  declarations: [TabToggleComponent, TabToggleOptionComponent],
  exports: [TabToggleComponent, TabToggleOptionComponent],
  imports: [CommonModule],
})
export class TabToggleModule {}
